export default "__VITE_ASSET__DcDHxTci__"